import { useThemeStore } from "@stores/theme.store";
import { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import { BiLogoWhatsapp } from "react-icons/bi";
import { useMutation, useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import MaleLogo from "@assets/images/avatar.png";
import FemaleLogo from "@assets/images/avatar-female.png";
import { Spiner } from "@components/loaders/spiner";
import { NoticeType } from "antd/es/message/interface";

export const SettingUpdateAccountPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";
  const gender = dataNis?.data?.gender ?? "";

  const { data, isPending, refetch } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
  });

  const { mutate: onUpdateBio, isPending: isPendingUpdateBio } = useMutation({
    mutationFn: SchoolService.updateStudentBiography,
    onSuccess: (response) => {
      setShowMessage(true);
      setMessageType("success");
      setShowMessageText(response.message);

      refetch();
    },
    onError: (error: any) => {
      setShowMessage(true);
      setMessageType("error");
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  useEffect(() => {
    setAppBar({ title: "Edit Profil", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      title: "Edit Profil",
      filter: false,
    });
  }, [setHeader, setAppBar]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4">
        <div className="tw-mb-4 tw-flex tw-items-center tw-rounded-md tw-bg-other-100 tw-text-center card-body">
          <div className="tw-me-4">
            <img
              src={
                isPending
                  ? MaleLogo
                  : data?.data?.foto === null || data?.data?.foto === ""
                  ? gender === "Pria" || gender === "PRIA" || gender === ""
                    ? MaleLogo
                    : FemaleLogo
                  : `https://sipiat2.pesantrenalirsyad2.org/assets/fotosiswa/${data?.data?.foto}`
              }
              alt=""
              className="tw-w-[60px] tw-h-[60px] tw-object-cover tw-rounded-full tw-aling-middle"
            />
          </div>
          <div className="tw-text-left">
            <div className="tw-text-lg tw-font-medium tw-text-primary">
              {data?.data?.namasiswa ?? "---"}
            </div>
            <div className="tw-text-sm tw-text-neutral-text-2">
              Kelas {data?.data?.kelas}
            </div>
          </div>
        </div>

        <Form
          className=""
          autoComplete="off"
          initialValues={{
            nis: nis,
            namasiswa: data?.data?.namasiswa ?? "---",
            telephon: data?.data?.telephon ?? "---",
            kelas: data?.data?.kelas ?? "---",
          }}
          onFinish={(data) => onUpdateBio(data)}
        >
          <div className="tw-mb-4 tw-bg-other-100 tw-rounded-md card-body">
            {isPending ? (
              <div className="tw-text-center">
                <Spiner />
              </div>
            ) : (
              <>
                <Form.Item label="NIS" name="nis" className="tw-mb-4">
                  <Input
                    className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="NIS"
                    disabled={true}
                  />
                </Form.Item>

                <Form.Item
                  label="No. Telepon"
                  name="telephon"
                  className="tw-mb-4"
                >
                  <Input
                    suffix={
                      <BiLogoWhatsapp size={20} className="tw-text-[#91C60B]" />
                    }
                    className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                    placeholder="-----"
                  />
                </Form.Item>
              </>
            )}
          </div>

          <div className="tw-bg-other-100 tw-rounded-md card-body">
            <Button
              type="primary"
              htmlType="submit"
              loading={isPendingUpdateBio}
              className="tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
            >
              Simpan
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};
